import { reportLoadingInterceptor } from "../reportLodingInterceptor";

export const initializeInterceptors = () => {
  reportLoadingInterceptor();
  // Add any future interceptor initializations here
};
